'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _TypeContext = require('../editors/TypeContext');

var _reactFulcrum = require('@upgrowth/react-fulcrum');

var _layouts = require('./layouts');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = (0, _TypeContext.withTypes)(function (_ref) {
  var _ref$layout = _ref.layout,
      layout = _ref$layout === undefined ? {} : _ref$layout,
      values = _ref.values,
      _ref$variant = _ref.variant,
      variant = _ref$variant === undefined ? "none" : _ref$variant,
      addOptions = _ref.addOptions,
      onRemove = _ref.onRemove,
      onReorder = _ref.onReorder;
  var _layout$order = layout.order,
      order = _layout$order === undefined ? [] : _layout$order;
  var orderedChildren = (0, _layouts.orderChildren)(values, order);
  return _react2.default.createElement('div', {
    className: 'ListLayout variant-' + variant
  }, (0, _lodash.map)(orderedChildren, function (child) {
    return _react2.default.createElement('div', {
      className: 'ListLayoutCell',
      key: child.key
    }, child.el, _react2.default.createElement('div', {
      className: 'actions'
    }, onRemove && _react2.default.createElement(_reactFulcrum.Button, {
      className: 'action-remove',
      onClick: function onClick() {
        return onRemove(child.key);
      }
    }, '-')));
  }), addOptions && _react2.default.createElement('div', {
    className: 'ListLayoutCell add'
  }, addOptions));
});